import styled from 'styled-components';
import { colors } from '@dexma/ui-components';

export const StyledOptionsForm = styled.div`
    .options-title-label-block {
        padding: 10px 22px 0px 30px;
        justify-content: end;

        span {
            font-weight: 700;
            color: ${colors.gray700};
        }
    }
`;
